<template>
    <v-dialog v-model="show" scrollable max-width="50%">
        <v-form>
            <v-card class="pa-8" v-if="!isLoading">
                <v-card-title class="mb-8 d-flex align-end">
                    <span class="text-h4 font-weight-medium mr-4">
                        Annuity
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <individuals-dropdown :individualsDropdown="individualsDropdown" v-model="form"></individuals-dropdown>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-menu
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="dateOfEntry"
                                        label="Date of Entry"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        @blur="form.date_of_entry = parseDate(dateOfEntry)"
                                        :error-messages="form.errors.get('date_of_entry')"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateOfEntry"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-menu
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="openDate"
                                        label="Open Date"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        @blur="form.open_date = parseDate(openDate)"
                                        :error-messages="form.errors.get('open_date')"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="openDate"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-menu
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="startDate"
                                        label="Start Date"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        @blur="form.start_date = parseDate(startDate)"
                                        :error-messages="form.errors.get('start_date')"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="startDate"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="form.company_name"
                                label="Company"
                                required
                                :error-messages="form.errors.get('company_name')"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-select
                                :items="typeLabels"
                                label="Type of account"
                                v-model="form.type_of_account_cd"
                                :error-messages="form.errors.get('type_of_account_cd')"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="form.account_number"
                                label="Account number"
                                :error-messages="form.errors.get('account_number')"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-currency-field
                                label="Account balance"
                                v-model="form.value"
                                :error-messages="form.errors.get('value')"
                            ></v-currency-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-currency-field
                                label="Income value"
                                v-model="form.annuity_value"
                                :error-messages="form.errors.get('annuity_value')"
                            ></v-currency-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-currency-field
                                label="Health care rider"
                                v-model="form.health_care_rider"
                                :error-messages="form.errors.get('health_care_rider')"
                            ></v-currency-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-currency-field
                                label="Health care multiplier"
                                v-model="form.health_care_multiplier"
                                :error-messages="form.errors.get('health_care_multiplier')"
                            ></v-currency-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-currency-field
                                v-model="form.deposits"
                                label="Deposits"
                                :error-messages="form.errors.get('deposits')"
                            ></v-currency-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-currency-field
                                v-model="form.withdrawals"
                                label="Withdrawals"
                                :error-messages="form.errors.get('withdrawals')"
                            ></v-currency-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-currency-field
                                v-model="form.account_start_value"
                                label="Account start value"
                                :error-messages="form.errors.get('account_start_value')"
                            ></v-currency-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="form.from"
                                label="From"
                                :error-messages="form.errors.get('from')"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="form.series"
                                label="Series"
                                :error-messages="form.errors.get('series')"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="form.rider"
                                label="Rider"
                                :error-messages="form.errors.get('rider')"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="text-center mt-12">
                            <v-btn color="primary" depressed rounded height="48" width="300" @click="save">
                                Save
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card class="pa-8" v-else>
                <v-progress-circular
                    class="d-flex mx-auto"
                    indeterminate
                    size="50"
                    color="primary"
                >
                </v-progress-circular>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import { Form } from 'vform'
import {mapState} from "vuex";
import IndividualsDropdown from "@/components/IndividualsDropdown";
import dayjs from 'dayjs';
import VCurrencyField from "@/components/VCurrencyField";

export default {
    components: {
        IndividualsDropdown,
        VCurrencyField,
    },
    props: {
        value: {
            required: true,
            type: Boolean
        },
        householdId: {
            required: true,
            type: Number
        },
        annuity: {
            type: [Object, null]
        },
    },
    data() {
        return {
            form: new Form({
                id: null,
                owner: null,
                individual_id: null,
                date_of_entry: null,
                start_date: null,
                company_name: null,
                type_of_account_cd: null,
                account_number: null,
                value: 0,
                annuity_value: 0,
                health_care_rider: 0,
                health_care_multiplier: 0,
                deposits: 0,
                withdrawals: 0,
                account_start_value: 0,
                from: null,
                series: null,
                rider: null,
                return_percentage: 0,
                close_date: null,
                open_date: null,
            }),
            openDate: null,
            dateOfEntry: null,
            startDate: null,
            isLoading: false,
        }
    },
    computed: {
        ...mapState('individuals', ['individualsDropdown']),
        ...mapState('constants', ['typeLabels']),
        ...mapState('auth', ['user']),
        show: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            }
        },
    },
    mounted() {
        if (this.annuity !== null) {
            this.form.fill(this.annuity);
            this.startDate = this.form.start_date;
            this.openDate = this.form.open_date;
            this.dateOfEntry = this.form.date_of_entry;
        }
    },
    methods: {
        save() {
            this.form.start_date = this.parseDate(this.startDate);
            this.form.date_of_entry = this.parseDate(this.dateOfEntry);

            this.isLoading = true;

            if (this.form.id === null) {
                this.form.post('/api/households/' + this.user.household_id + '/account-manager-annuities', { showLoader: false })
                    .then(() => this.postSave())
                    .catch(() => this.isLoading = false);
            } else {
                this.form.put('/api/households/' + this.user.household_id + '/account-manager-annuities/' + this.form.id, { showLoader: false })
                    .then(() => this.postSave())
                    .catch(() => this.isLoading = false);
            }
        },
        postSave() {
            this.$emit('reload');
            this.show = this.isLoading = false;
            this.form.reset();
        },
        parseDate(date) {
            if (!date) return null;

            return dayjs(date).format('MM/DD/YYYY');
        }
    },
}
</script>
